export default {
    common: {
        meta: {
            title: 'CrispyVoice',
            subTitle: 'Die Stimme Deiner Zukunft'
        },
        mediums: {
            commercials: {
                title: 'Werbung',
                examples: 'TV, Plakatwände, YouTube und Radio'
            },
            'info-videos': {
                title: 'Info-Videos',
                examples: 'E-Learning, Produktvideo, Imagevideo'
            },
            'social-media': {
                title: 'Soziale Medien',
                examples: 'Facebook, YouTube, Instagram, TikTok'
            },
            public: {
                title: 'Öffentlich',
                examples: 'Feueralarm, Lautsprecheransagen, Amok-Alarm'
            }
        },
        buttons: {
            cancel: 'Abbrechen',
            back: 'Zurück',
            submit: 'Absenden'
        },
        errors: {
            somethingWentWrong: 'Etwas ist schiefgelaufen!'
        },
        formats: {
            mp3: 'MP3',
            wav: 'WAV'
        },
        timeframes: {
            day_one: 'Tag',
            day_other: 'Tage',
            week_one: 'Woche',
            week_other: 'Wochen',
            month_one: 'Monat',
            month_other: 'Monate',
            year_one: 'Jahr',
            year_other: 'Jahre'
        },
        'contact-speaker': 'Kontakt zu {{shortName}}'
    },
    hero: {
        testimonial:
            'Ich bin begeistert von {{name}}s KI-Stimme für unsere internen Projekte und Berechnungen, während wir für Werbe- und Social-Media-Kampagnen die natürliche Stimme verwenden.',
        title: 'Deine professionelle und rechtlich abgesicherte KI-Stimme.',
        subTitle:
            'Erstelle deinen individuellen Text in Minuten und lade nach der Zahlung die Audiodatei samt Freigabedokument herunter.'
    },
    'medium-selection': {
        header: 'Wo möchtest du meine Stimme einsetzen?',
        'price-from': 'ab {{currency}} {{basePrice}}',
        'included-characters': '{{included}} Zeichen inklusive',
        'price-additional-characters': '{{currency}} {{price}} / zusätzliches Zeichen',
        'unrestricted-usage': 'Unbefristete Lizenz',
        'restricted-usage': '{{value}} $t(common:timeframes.{{unit}}, { "count": {{value}} }) Lizenz',
        api: {
            title: 'Schnittstelle',
            subTitle: 'auf Anfrage'
        }
    },
    'audio-generation': {
        header: 'Jetzt Text generieren!',
        'copy-protection-info': 'Das Knuspern? Nur Preview-Wasserzeichen. Deine gekaufte Datei ist knusper-frei.',
        buttons: {
            generate: 'Generieren',
            'please-wait': 'Bitte warten...',
            stop: 'Stopp'
        },
        'text-placeholder': 'Gib hier deinen Text ein...',
        'recording-prefix': 'Aufnahme',
        'take-prefix': 'Version',
        'available-languages': 'Verfügbare Sprachen',
        'supported-languages':
            'Wir unterstützen 29 Sprachen: Englisch (USA, UK, Australien, Kanada), Japanisch, Chinesisch, Deutsch, Hindi, Französisch (Frankreich, Kanada), Koreanisch, Portugiesisch (Brasilien, Portugal), Italienisch, Spanisch (Spanien, Mexiko), Indonesisch, Niederländisch, Türkisch, Filipino, Polnisch, Schwedisch, Bulgarisch, Rumänisch, Arabisch (Saudi-Arabien, VAE), Tschechisch, Griechisch, Finnisch, Kroatisch, Malaiisch, Slowakisch, Dänisch, Tamil, Ukrainisch & Russisch.'
    },
    checkout: {
        header: 'Wähle eine oder mehrere Versionen!',
        description:
            'Wähle deine bevorzugten Audioversionen, indem du die Checkboxen neben jedem Player anklickst. Du kannst eine oder mehrere Versionen auswählen, die dann in deinem Downloadpaket enthalten sind. So kannst du sie später in deiner eigenen Audiosoftware kombinieren oder bearbeiten und individuelle Arrangements erstellen.',
        'no-recordings-yet': 'Bitte generiere zuerst einen Text, um hier etwas zu sehen!',
        play: 'Abspielen',
        stop: 'Stopp',
        'accept-terms': 'Ja, ich akzeptiere die <0>AGB</0><1/>.',
        'order-now': 'Jetzt bestellen',
        'allowed-medium_one': 'Erlaubtes Medium',
        'allowed-medium_other': 'Erlaubte Medien',
        format: 'Format',
        'including-release-document': 'Inklusive Freigabedokument',
        'download-after-payment': 'Download direkt nach Bezahlung',
        columns: {
            version: 'Version',
            text: 'Text',
            play: 'Abspielen',
            buy: 'Kaufen'
        },
        variants: 'Variante',
        variants_other: 'Varianten',
        'line-item_zero': '{{speakerName}} – {{mediumTitle}}: {{textLength}} Zeichen',
        'line-item':
            '{{speakerName}} – {{mediumTitle}}: {{textLength}} Zeichen, inkl. {{count}} $t(checkout:variants, { "count": {{count}} })'
    },
    auth: {
        titles: {
            forgotPassword: 'Passwort vergessen?',
            login: 'Anmelden',
            register: 'Registrieren',
            resetPassword: 'Passwort zurücksetzen',
            verifyCode: 'Code eingeben'
        }
    },
    login: {
        meta: {
            title: 'Anmeldung',
            subTitle: 'CrispyVoice Kundenportal'
        },
        email: 'E-Mail-Adresse',
        password: 'Passwort',
        'remember-me': 'Eingeloggt bleiben',
        login: 'Einloggen',
        signIn: 'Anmelden',
        forgotPassword: 'Passwort vergessen?',
        createAnAccount: 'Jetzt registrieren',
        resetPassword: 'Passwort zurücksetzen',
        backToLogin: 'Zurück zur Anmeldung',
        checkYourEmail: 'Überprüfe deine E-Mails',
        emailVerificationCodeSent: 'Wir haben dir einen Code zur Bestätigung deiner E-Mail-Adresse gesendet.',
        newPassword: 'Neues Passwort',
        confirmNewPassword: 'Neues Passwort bestätigen',
        check2faApp: 'Überprüfen Sie Ihre 2FA-App',
        enter2faCode: 'Bitte geben Sie Ihren 2FA-Code ein, um Ihre Identität zu bestätigen.'
    },
    register: {
        heading: 'Registrieren',
        subHeading: 'Hinterlasse deine Daten – wir melden uns bei dir und richten deinen Zugang ein.',
        name: 'Name',
        namePlaceholder: 'Max Mustermann',
        email: 'E-Mail-Adresse',
        emailPlaceholder: 'name@firma.de',
        company: 'Firma',
        companyPlaceholder: 'Dein Unternehmen',
        message: 'Nachricht',
        messagePlaceholder: 'Beschreibe kurz dein Anliegen, wir melden uns bei dir.',
        submit: 'Registrierung anfragen',
        hint: 'Wir melden uns in der Regel innerhalb von 24 Stunden.',
        success: 'Danke! Wir haben deine Anfrage erhalten und melden uns zeitnah bei dir.',
        voiceArtistsLink: 'Zu unseren VoiceArtists',
        voiceArtistsPath: '/stimmen',
        backToLogin: 'Zurück zur Anmeldung'
    },
    account: {
        heading: 'Einstellungen',
        language: 'Anzeigesprache',
        save: 'Speichern',
        password: 'Passwort',
        'change-password': 'Passwort ändern',
        'current-password': 'Aktuelles Passwort',
        'new-password': 'Neues Passwort',
        'repeat-new-password': 'Neues Passwort bestätigen',
        'password-change-successful': 'Passwort erfolgreich geändert!',
        invoices: 'Rechnungen',
        'invoice-date': 'Datum',
        'invoice-amount': 'Betrag',
        'invoice-status': 'Status',
        'invoice-link': 'Rechnung',
        'invoice-view': 'Ansehen',
        validation: {
            password: {
                currentRequired: 'Aktuelles Passwort ist erforderlich',
                repeatRequired: 'Bitte neues Passwort wiederholen',
                mismatch: 'Passwörter stimmen nicht überein',
                currentInvalid: 'Aktuelles Passwort ist falsch'
            }
        }
    },
    onboarding: {
        emails: {
            purchaseComplete: {
                subject: 'Voice Owner Approved: Deine Audio-Daten sind ready! ',
                heading: 'Hi {{user_name}},',
                intro: 'Bestellt. Generiert. Fertig!',
                download_one: 'Deine professionelle KI-Audio-Datei wartet auf dich:',
                download_other: 'Deine professionellen KI-Audio-Dateien warten auf dich:',
                click: 'Download starten',
                'features-header': 'Was du bekommst:',
                features_one: [
                    'KI-Audio-Datei (MP3, 128 kBit/s)',
                    'Rechnung mit Auftragsnummer',
                    'Freigabedokument für rechtssichere Nutzung',
                    'Link gültig für 12 Monate',
                ],
                features_other: [
                    'KI-Audio-Dateien (MP3, 128 kBit/s)',
                    'Rechnung mit Auftragsnummer',
                    'Freigabedokument für rechtssichere Nutzung',
                    'Link gültig für 12 Monate',
                ],
                outro:
                    '<strong>Wichtig</strong>: Speichere den Link oder lade die Datei direkt herunter<br/>Und bitte!',
                claimAccountIntro:
                    'Falls Du noch kein Konto hast, kannst Du dir unter dem folgenden Link eines erstellen. Du musst nur noch ein Passwort eingeben und schon hast Du zukünftig eine Übersicht über alle deine Käufe.',
                claimAccount: 'Konto erstellen'
            }
        }
    },
    footer: {
        gtc: 'Nutzungsbedingungen',
        imprint: 'Impressum',
        'contact-real-voice': 'Natürliche Stimme kontaktieren',
        copyright: '\u24B8 CrispyVoice {{year}}'
    },
    navigation: {
        title: 'CrispyVoice-Portal',
        subTitle: 'Willkommen',
        home: 'Startseite',
        purchases: 'Käufe'
    },
    contact: {
        // Noch keine Einträge vorhanden
    },
    gtc: {
        heading: 'Allgemeine Geschäftsbedingungen (AGB) für Kunden von Voice Artists auf CrispyVoice ',
        text: `# 1. Geltungsbereich und Vertragsparteien
1.1. Diese Allgemeinen Geschäftsbedingungen (nachfolgend "AGB") regeln das
Vertragsverhältnis zwischen mir als professioneller Sprecherin/professionellem
Sprecher (nachfolgend "Voice Artist") und Ihnen als Endkunden (nachfolgend "Kunde"),
der meine mittels Künstlicher Intelligenz geklonte Stimme über die Plattform
CrispyVoice (nachfolgend "Plattform") erwirbt.  
1.2. Die Plattform CrispyVoice dient ausschließlich als technischer Dienstleister und
Vermittler zwischen mir und Ihnen. Ihr Vertragspartner bin ausschließlich ich als Voice
Artist.  
1.3. Mit der Bestellung einer KI-generierten Audiodatei mit meiner Stimme akzeptieren
Sie diese AGB in vollem Umfang.
# 2. Leistungsbeschreibung
2.1. Als Voice Artist biete ich über die Plattform die Erstellung von Audiodateien mit
meiner KI-geklonten Stimme an. Die Audiodateien werden basierend auf dem von Ihnen
eingereichten Text erstellt.  
2.2. Die Audiodateien werden in MP3-Format mit 128 kbit/s in Mono-Qualität
bereitgestellt.  
2.3. Nach erfolgreicher Zahlung erhalten Sie einen Download-Link zur erstellten
Audiodatei sowie einen einmaligen Identifikationscode, der dieser Datei zugeordnet ist.  
2.4. Ich behalte mir das Recht vor, Texte, die gegen geltendes Recht verstoßen oder
ethisch bedenkliche Inhalte enthalten, abzulehnen. Die Überprüfung erfolgt
automatisiert durch KI-Systeme der Plattform.  
# 3. Registrierung und Bestellprozess
3.1. Für die Nutzung meiner KI-Stimme über die Plattform ist eine kostenlose
Registrierung erforderlich. Sie verpflichten sich, wahrheitsgemäße Angaben zu machen
und Ihre Zugangsdaten vertraulich zu behandeln.  
3.2. Der Bestellprozess umfasst folgende Schritte: a) Auswahl meiner Stimme b) Auswahl
des Verwendungszwecks und der entsprechenden Lizenz c) Eingabe des zu
vertönenden Textes d) Auswahl der gewünschten Anzahl an Takes/Versionen e)
Überprüfung und Bestätigung der Bestellung f) Bezahlung g) Sofortiger Download der
generierten Audiodatei  
3.3. Sie erhalten unmittelbar nach erfolgreicher Bezahlung Zugang zur bestellten
Audiodatei. Mit diesem Zeitpunkt gilt der Vertrag als erfüllt.
# 4. Preise und Zahlungsbedingungen
4.1. Die Preise für die verschiedenen Verwendungszwecke werden von mir als Voice
Artist festgelegt und sind auf der Plattform transparent ausgewiesen.  
4.2. Die Grundpreise umfassen eine gewisse Anzahl an Zeichen. Für jeden zusätzlichen Zeichen
fallen die auf der Plattform angegebenen Zusatzkosten an.  
4.3. Bei Bestellung mehrerer Takes oder Versionen des gleichen Textes wird ein
prozentualer Aufschlag berechnet. Bei Textänderungen in weiteren Takes wird die
Lizenzgebühr doppelt berechnet, falls diese Option ausgewählt wurde.  
4.4. Der Gesamtpreis wird Ihnen vor der finalen Bestellbestätigung deutlich angezeigt.  
4.5. Die Bezahlung erfolgt ausschließlich über die angebotenen Zahlungsmethoden
(Kreditkarte via Stripe or TWINT). Alle Zahlungen sind sofort fällig und werden vor
Bereitstellung der Audiodatei vollständig eingezogen.  
4.6. Die Rechnungsstellung erfolgt über Stripe mit Ausweis der im jeweiligen Land des
Kunden gültigen Mehrwertsteuer, sofern ich als Voice Artist mehrwertsteuerpflichtig
bin. Bei internationalen Transaktionen gilt der Mehrwertsteuersatz des Landes, in dem
der Kunde seinen Sitz hat, sofern dies nach den geltenden Steuervorschriften
erforderlich ist.  
4.7. Für Kunden mit Sitz in der Europäischen Union: Bei Angabe einer gültigen
Umsatzsteuer-Identifikationsnummer kann die Rechnung ohne Mehrwertsteuer
ausgestellt werden, sofern die gesetzlichen Voraussetzungen für eine
innergemeinschaftliche Leistung vorliegen.
# 5. Lizenz- und Nutzungsrechte
5.1. Mit dem Erwerb einer Audiodatei erhalten Sie von mir als Voice Artist ein nichtexklusives, nicht übertragbares Nutzungsrecht an der KI-generierten Stimme für den bei
der Bestellung ausgewählten Verwendungszweck.  
5.2. Die Lizenzdauer wird von mir als Voice Artist festgelegt und ist für jeden
Nutzungstyp während des Bestellvorgangs klar ausgewiesen. Die spezifische Dauer
Ihrer Lizenz ist in Ihrer Auftragsbestätigung dokumentiert und kann Folgendes
umfassen: a) Begrenzte Zeitdauer (z.B. 1 Jahr, 2 Jahre) b) Unbefristete Lizenz (zeitlich
unbegrenzt) c) Individuelle Lizenzperioden gemäß spezifischer Angabe  
5.3. Das Nutzungsrecht ist weltweit gültig, sofern von mir während des Bestellvorgangs
nicht anders angegeben.  
5.4. Sie sind nicht berechtigt: a) Die Audiodatei für andere als die erworbenen
Verwendungszwecke zu nutzen b) Die Audiodatei an Dritte weiterzugeben oder zu
verkaufen c) Die Audiodatei für das Training von Sprachmodellen oder KI-Systemen zu
verwenden d) Die Audiodatei zu verändern oder zu bearbeiten e) Die Audiodatei für
illegale, betrügerische oder rufschädigende Zwecke zu verwenden f) Die Audiodatei
nach Ablauf der Lizenzperiode weiterhin zu nutzen (bei zeitlich begrenzten Lizenzen)  
5.5. Bei Zuwiderhandlung gegen diese Bestimmungen erlischt das Nutzungsrecht
automatisch und ich behalte mir rechtliche Schritte vor.  
5.6. Wenn Sie eine zeitlich begrenzte Lizenz verlängern oder die Nutzungsrechte ändern
möchten, müssen Sie eine neue Bestellung aufgeben oder mich direkt über die
Plattform kontaktieren.  
5.7. Bei kommerziellen Nutzungen sind Sie dafür verantwortlich, Aufzeichnungen darüber
zu führen, wann und wie die Audiodatei verwendet wurde, um die Einhaltung der
Lizenzdauer zu gewährleisten.
# 6. Kennzeichnung von KI-generierten Inhalten
6.1. Jede erworbene Audiodatei erhält einen einmaligen Identifikationscode, der in einem
Freigabedokument enthalten ist und zur eindeutigen Identifizierung der lizenzierten
Datei dient.  
6.2. Sie verpflichten sich, bei der Verwendung der Audiodatei die jeweils geltenden
gesetzlichen und plattformspezifischen Kennzeichnungspflichten für KI-generierte
Inhalte einzuhalten.  
6.3. Falls eine Plattform oder ein Medium, auf dem Sie die Audiodatei verwenden, eine
spezifische Kennzeichnung von KI-generierten Inhalten vorschreibt, sind Sie
verpflichtet, diese Kennzeichnung vorzunehmen. Der mit der Audiodatei gelieferte
einmalige Identifikationscode kann für diesen Zweck verwendet werden.  
6.4. Auf Anfrage stelle ich Ihnen eine Bestätigung zur Verfügung, dass Sie die Audiodatei
rechtmäßig erworben und lizenziert haben.
# 7. Gewährleistung und Haftung
7.1. Als Voice Artist übernehme ich keine Gewähr für die inhaltliche Richtigkeit der von
Ihnen eingereichten Texte.  
7.2. Reklamationen bezüglich der Qualität der KI-generierten Audiodateien sind
ausgeschlossen. Bei Buchung meiner natürlichen Stimme kann der bereits gezahlte
Betrag nach meinem Ermessen angerechnet werden.  
7.3. Meine Haftung als Voice Artist ist auf Vorsatz und grobe Fahrlässigkeit beschränkt.
Die Haftung für leichte Fahrlässigkeit ist ausgeschlossen, soweit gesetzlich zulässig.  
7.4. Ich hafte nicht für Schäden, die durch missbräuchliche oder rechtswidrige
Verwendung der Audiodateien durch Sie entstehen.  
7.5. Sie stellen mich als Voice Artist von allen Ansprüchen Dritter frei, die aus der
Nutzung der Audiodateien durch Sie entstehen könnten.  
7.6. Die maximale Haftung ist in jedem Fall auf den von Ihnen gezahlten Kaufpreis
beschränkt.
# 8. Datenschutz
8.1. Ihre personenbezogenen Daten (Firma, Anschrift, Telefonnummer, E-Mail) werden
ausschließlich zum Zweck der Vertragsabwicklung und gemäß den geltenden
Datenschutzbestimmungen erhoben und verarbeitet.  
8.2. Die Daten werden auf Servern von AWS und Hetzner in den USA und in Europa gespeichert. Sie erklären sich
mit dieser Speicherung ausdrücklich einverstanden.  
8.3. Die von Ihnen eingereichten Texte werden ausschließlich zur Erstellung der
Audiodateien verwendet und sind nur für mich als Voice Artist einsehbar.  
8.4. Die erstellten Audiodateien werden unbegrenzt gespeichert und bleiben für Sie zum
Download verfügbar.  
8.5. Sie haben jederzeit das Recht auf Auskunft, Berichtigung, Löschung und
Einschränkung der Verarbeitung Ihrer personenbezogenen Daten. Entsprechende
Anfragen sind an meine Kontakt-E-Mail zu richten.
# 9. Urheberrecht und geistiges Eigentum
9.1. Das KI-Modell zur Generierung der Stimme ist geistiges Eigentum von CrispyVoice.  
9.2. Die Persönlichkeitsrechte an meiner Originalstimme verbleiben bei mir als Voice
Artist.  
9.3. Sie erwerben ausschließlich die in Abschnitt 5 definierten Nutzungsrechte an der
generierten Audiodatei.  
9.4. Sie sind verpflichtet, bei der Nutzung der Audiodateien alle anwendbaren
Urheberrechts- und Persönlichkeitsrechtsbestimmungen zu beachten.
# 10. Vertragslaufzeit und Kündigung
10.1. Der Vertrag zwischen mir als Voice Artist und Ihnen endet mit der Bereitstellung der
Audiodatei, die Nutzungsrechte bestehen gemäß den in Abschnitt 5 genannten
Bedingungen fort.  
10.2. Ich bin berechtigt, die Nutzungsrechte mit sofortiger Wirkung zu entziehen, wenn
Sie gegen diese AGB verstoßen, insbesondere wenn die Audiodateien für rechtswidrige
oder rufschädigende Zwecke verwendet werden.
# 11. Änderungen der AGB
11.1. Ich behalte mir das Recht vor, diese AGB jederzeit zu ändern. Änderungen werden
Ihnen per E-Mail oder über den Newsletter mitgeteilt.  
11.2. Sie werden über Änderungen am Stimmmodell oder an den Nutzungsbedingungen
per Newsletter informiert, sofern Sie diesen abonniert haben.  
11.3. Für bereits erworbene Audiodateien gelten die zum Zeitpunkt des Kaufs gültigen
AGB.
# 12. Streitbeilegung
12.1. Bei Streitigkeiten aus oder im Zusammenhang mit diesem Vertrag verpflichten wir
uns, zunächst eine einvernehmliche Lösung anzustreben. Beanstandungen und
Reklamationen richten Sie bitte direkt an mich als Voice Artist unter der angegebenen
Kontakt-E-Mail.  
12.2. Ich werde auf Ihre Beanstandung innerhalb von 14 Tagen reagieren und eine Lösung
vorschlagen.  
12.3. Sollte keine Einigung erzielt werden können, kann vor Beschreitung des Rechtswegs
eine Mediation nach den Regeln der Schweizerischen Kammer für Wirtschaftsmediation
(SKWM) oder des Schweizerischen Dachverbands Mediation (SDM) durchgeführt
werden. Die Kosten der Mediation werden von beiden Parteien zu gleichen Teilen
getragen, sofern keine andere Vereinbarung getroffen wird.
# 13. Schlussbestimmungen
13.1. Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die
Wirksamkeit der übrigen Bestimmungen davon unberührt.  
13.2. Es gilt ausschließlich das Recht des Landes, in dem ich als Voice Artist meinen
Wohnsitz habe, unter Ausschluss des UN-Kaufrechts.  
13.3. Gerichtsstand für alle Streitigkeiten aus oder im Zusammenhang mit diesen AGB ist
mein Wohnsitz als Voice Artist, soweit gesetzlich zulässig.  
13.4. Diese AGB wurden zuletzt aktualisiert am [01.05.2025].`
    }
};
